/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getUserSummaryConfig } from '../../../../config/apiConfig';
import getLogger from '../../../../utils/logger';

export const getActivitiesAndTaskConfigurations = async () => {
  // Get auth header config
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v1/adminconfiguration`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const saveActivitiesAndTaskConfigurations = async (data) => {
  // post auth header config
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v1/saveadminconfiguration`;
  return axios
    .post(requestUrl, data, config)
    .then(async (response) => {
      return response;
    })
    .catch(() => {
      return null;
    });
};

export const getTranslationsForCard = async (cardId) => {
  // Get auth header config
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v2/GetTranslationsForCard?cardId=${cardId}`;
  return axios
    .get(requestUrl, config)
    .then(async (resp) => {
      let response = {};
      if (resp.data) {
        response = resp.data;
      }
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      return null;
    });
};

export const saveTranslationsForCard = async (cardId, translatedProperty, translations) => {
  // post auth header config
  const data = { cardId, translatedProperty, translations };
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v2/SaveTranslationsForCard`;
  return axios
    .post(requestUrl, data, config)
    .then(async (response) => {
      return response;
    })
    .catch((err) => {
      getLogger().error(err);
      return null;
    });
};
